import React from 'react';
import { StyleProp, TextStyle } from 'react-native';

import { RefreshButton } from './refresh-button';
import { TextInput, TextInputProps } from './text-input';

export interface SearchbarProps {
	value: string;
	onChangeText: (text: string) => void;
	placeholder?: string;
	onRefreshPress?: () => void;
	showRefreshButton?: boolean;
	style?: StyleProp<TextStyle>;
	autoFocus?: boolean;
	mode?: string;
	onKeyPress?: TextInputProps['onKeyPress'];
	testID?: string;
}

export const Searchbar: React.FC<SearchbarProps> = ({
	value,
	onChangeText,
	placeholder = 'Search',
	onRefreshPress,
	showRefreshButton = false,
	style,
	autoFocus,
	mode,
	onKeyPress,
	testID,
}) => {
	return (
		<TextInput
			value={value}
			onChangeText={onChangeText}
			placeholder={placeholder}
			testID={testID}
			mode={(mode as 'flat' | 'outlined') || 'outlined'}
			style={style}
			autoFocus={autoFocus}
			enterKeyHint="search"
			onKeyPress={onKeyPress}
			right={showRefreshButton && onRefreshPress ? (
				<RefreshButton
					onPress={onRefreshPress}
					size={20}
					iconColor="#666"
				/>
			) : undefined}
		/>
	);
};
